import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const trashProjectsDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'trash-projects-directory',
	path: '/secure/projects/trash',
	exact: true,
};
